<template>
  <div id="home" class="two-banner-wrap">
    <div
      class="two-banner-slider custom-slider"
      ref="viewport"
      @mouseenter="pause"
      @mouseleave="onMouseLeave"
    >
      <!-- Track -->
      <div
        class="slider-track"
        :style="trackStyle"
        ref="track"
      >
        <div class="slider-slide" v-for="slide in carouselItems" :key="slide.id">
          <div :class="slide.class">
            <div class="d-table">
              <div class="d-table-cell">
                <div class="container">
                  <div class="banner-content">
                    <span>
                      <img :src="slide.image" alt="Banner" />
                      {{ slide.subTitle }}
                    </span>
                    <h1>{{ slide.heading }}</h1>
                    <div class="banner-btn">
                      <a class="cmn-banner-btn" href="#service">
                        <i class="bx bx-note"></i>
                        Comenzar
                      </a>
                      <a class="banner-right-btn" href="#info">
                        <i class="bx bx-note"></i>
                        Preguntas frecuentes
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Nav -->
      <button class="slider-nav prev" @click="prev" aria-label="Anterior">‹</button>
      <button class="slider-nav next" @click="next" aria-label="Siguiente">›</button>

      <!-- Dots -->
      <div class="slider-dots" role="tablist" aria-label="Indicadores del slider">
        <button
          v-for="(s, i) in carouselItems"
          :key="i"
          class="dot"
          :class="{ active: i === currentIndex }"
          @click="goTo(i)"
          :aria-label="`Ir al slide ${i+1}`"
          :aria-selected="i === currentIndex"
          role="tab"
        />
      </div>
    </div>

    <!-- Franja inferior con teléfono y contacto -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 p-0">
          <div class="banner-time-left">
            <ul>
              <li>
                <i class="bx bx-phone-call"></i>
                <span>(Servicio Técnico - 24h)</span>
                <a href="tel:+34623615128">+34 623 61 51 28</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 p-0">
          <div class="banner-time-right">
            <ul>
              <li>
                <i class="bx bx-timer"></i>
                <span>Horario de recepción:</span>
                <p>Atención técnica 24/7</p>
              </li>
              <li>
                <i class="bx bxs-contact"></i>
                <span>Contáctanos </span>
                <a href="mailto:serviciotecnico@plotix.es">serviciotecnico@plotix.es</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainBanner',
  data() {
    return {
      currentIndex: 0,
      timer: null,
      autoplayMs: 5000,

      // drag/swipe (ya no se usan, pero los dejo por si quieres reactivarlo en el futuro)
      isDragging: false,
      startX: 0,
      deltaX: 0,
      thresholdPx: 60,

      carouselItems: [
        {
          id: 1,
          class: 'two-banner-area two-banner-one',
          image: require('../../assets/img/jill_icon.png'),
          subTitle: 'Bienvenido a Plotix',
          heading: 'Servicio técnico experto en impresión digital',
        },
        {
          id: 2,
          class: 'two-banner-area two-banner-two',
          image: require('../../assets/img/jill_icon.png'),
          subTitle: 'Bienvenido a Plotix',
          heading: 'Cuidamos tus equipos como si fueran nuestros',
        },
        {
          id: 3,
          class: 'two-banner-area two-banner-three',
          image: require('../../assets/img/jill_icon.png'),
          subTitle: 'Bienvenido a Plotix',
          heading: 'Tu aliado en impresión digital',
        },
      ],
    };
  },
  computed: {
    trackStyle() {
      const base = -(this.currentIndex * 100);
      const dragPct = this.isDragging
        ? (this.deltaX / (this.$refs.viewport?.clientWidth || 1)) * 100
        : 0;
      return {
        transform: `translateX(calc(${base}% + ${dragPct}%))`,
        transition: this.isDragging ? 'none' : 'transform 0.6s ease',
      };
    },
  },
  mounted() {
    this.resume();
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeUnmount() {
    this.pause();
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.carouselItems.length;
    },
    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.carouselItems.length) %
        this.carouselItems.length;
    },
    goTo(i) {
      this.currentIndex = i;
      this.restart();
    },
    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    resume() {
      if (!this.timer) {
        this.timer = setInterval(() => this.next(), this.autoplayMs);
      }
    },
    restart() {
      this.pause();
      this.resume();
    },
    onResize() {
      this.isDragging = false;
      this.deltaX = 0;
    },

    // Los métodos de drag se dejan tal cual, pero ya no se llaman desde la plantilla.
    onTouchStart(e) {
      this.pause();
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.deltaX = 0;
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      this.deltaX = e.touches[0].clientX - this.startX;
    },
    onTouchEnd() {
      this.finishDrag();
    },
    onMouseDown(e) {
      this.pause();
      this.isDragging = true;
      this.startX = e.clientX;
      this.deltaX = 0;
    },
    onMouseMove(e) {
      if (!this.isDragging) return;
      this.deltaX = e.clientX - this.startX;
    },
    onMouseUp() {
      this.finishDrag();
    },
    onMouseLeave() {
      if (this.isDragging) this.finishDrag();
    },
    finishDrag() {
      const abs = Math.abs(this.deltaX);
      const dir = this.deltaX > 0 ? 'right' : 'left';
      this.isDragging = false;

      if (abs > this.thresholdPx) {
        dir === 'left' ? this.next() : this.prev();
      }
      this.deltaX = 0;
      this.resume();
    },
  },
};
</script>

<style scoped>
/* --- Evita deslizamientos laterales --- */
.two-banner-wrap {
  overflow-x: hidden;
}
.two-banner-wrap, .two-banner-wrap * {
  box-sizing: border-box;
}

/* =======================
   Slider sin librería
   ======================= */
.custom-slider {
  position: relative;
  width: 100%;
  overflow: hidden;
  touch-action: pan-y;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.slider-track {
  display: flex;
  width: 100%;
  will-change: transform;
}
.slider-slide {
  flex: 0 0 100%;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}

/* Flechas */
.slider-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  background: rgba(0,0,0,0.35);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
.slider-nav.prev { left: 12px; }
.slider-nav.next { right: 12px; }
.slider-nav:focus { outline: 2px solid #fff; }

/* Dots */
.slider-dots {
  position: absolute;
  left: 0; right: 0; bottom: 12px;
  display: flex;
  justify-content: center;
  gap: 8px;
  z-index: 2;
}
.slider-dots .dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  border: 0;
  background: rgba(255,255,255,0.5);
  cursor: pointer;
}
.slider-dots .dot.active { background: #fff; }

/* --- Banner principal --- */
.two-banner-area {
  min-height: 64vh;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center center;
}

/* --- Contenido del banner --- */
.banner-content {
  width: 100%;
  text-align: center;
}
.banner-content span {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  opacity: 0.9;
}
.banner-content h1 {
  margin: 10px 0 18px;
  font-weight: 800;
}

/* --- Botonera centrada --- */
.banner-btn {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
}
.banner-btn .cmn-banner-btn,
.banner-btn .banner-right-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 12px 20px;
  line-height: 1;
}

/* --- Franja inferior (teléfono/horario) --- */
.two-banner-wrap > .container-fluid {
  width: 100%;
  max-width: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-top: 0 !important;
}
.banner-time-left,
.banner-time-right {
  width: 100%;
  height: 100%;
}
.banner-time-left ul,
.banner-time-right ul {
  margin: 0;
  padding: 0;
}
.banner-time-left ul li,
.banner-time-right ul li {
  list-style: none;
}

/* --- Responsive: móvil --- */
@media (max-width: 991px) {
  .two-banner-area {
    min-height: 72vh;
  }
  .banner-content h1 {
    font-size: 28px;
    line-height: 1.2;
  }
  .banner-content span img {
    width: 28px;
    height: auto;
  }
  .banner-time-left,
  .banner-time-right {
    text-align: center;
    padding: 18px 16px;
  }

  .slider-nav {
    width: 34px; height: 34px;
    font-size: 20px; line-height: 34px;
  }
}

/* --- Responsive: desktop --- */
@media (min-width: 992px) {
  .banner-content h1 {
    font-size: 64px;
    line-height: 1.1;
  }
}

/* --- Fix hueco en tablet --- */
@media (min-width: 768px) and (max-width: 1199px) {
  .two-banner-wrap,
  .two-banner-wrap .two-banner-slider,
  .two-banner-area,
  .two-banner-area .d-table,
  .two-banner-area .d-table-cell {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
  .two-banner-area .d-table {
    min-height: 62vh;
  }
  .two-banner-wrap > .container-fluid {
    margin-top: -2px !important;
    padding-top: 0 !important;
  }
}

.slider-dots { display: none !important; }
</style>
